import request from '../utils/request.js'
var qywxAgentid = process.env.VUE_APP_QYWXAGENTID
// jssdk注入
export function getAgentConfig(data) {
    return request({
        url: '/user-login/wx/cpService/' + qywxAgentid + '/createAgentJsapiSignature',
        method: 'get',
        params: data
    })
}
export function loginByOAuth2(data) {
    return request({
        url: 'user-login/wx/doctorUser/loginByOAuth2',
        method: 'get',
        params: data
    })
}